import { getRequest, URL } from "shared/utils";
import * as types from "./actionTypes";

export function getRegions() {
  const url = `${URL.reference}/regions`;

  const request = getRequest(url);

  return {
    type: types.GET_REGIONS,
    payload: request,
  };
}

export function getDistinctCountries() {
  const url = `${URL.reference}/countries`;

  const request = getRequest(url);

  return {
    type: types.GET_COUNTRIES,
    payload: request,
  };
}

export function getStatesBasedOnCountry(countryId) {
  const url = `${URL.reference}/countries/${countryId}/states`;

  const request = getRequest(url);

  return {
    type: types.GET_STATES,
    payload: request,
  };
}

export function getDefaultValuesBasedOnCountry(countryId) {
  const url = `${URL.reference}/countries/${countryId}/defaultValues`;

  const request = getRequest(url);

  return {
    type: types.GET_DEFAULT_VALUES_ON_COUNTRY,
    payload: request,
  };
}

export function getRentPeriod() {
  const url = `${URL.reference}/rentPeriods`;

  const request = getRequest(url);

  return {
    type: types.GET_RENT_PERIOD,
    payload: request,
  };
}

export function getUOM() {
  const url = `${URL.reference}/unitsOfMeasure?uomType=Area`;

  const request = getRequest(url);

  return {
    type: types.GET_UNITS_OF_MEASUREMENT,
    payload: request,
  };
}

export function getCostCurrencies() {
  const url = `${URL.reference}/costCurrencies`;

  const request = getRequest(url);

  return {
    type: types.GET_COST_CURRENCY,
    payload: request,
  };
}

export function getDistinctUserRoles() {
  const url = `${URL.reference}/userRoles`;

  const request = getRequest(url);

  return {
    type: types.GET_DISTINCT_USER_ROLES,
    payload: request,
  };
}
